import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/preparations')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/preparations/' + id , payload)       
    } else {
        return Api.post('api/preparations' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/preparations/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/preparations/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};